export const PATH_AUTH = {
    login: '/login',
};

export const PATH_PAGE = {
    page404: '/404',
    page500: '/500',
};

export const PATH_DASHBOARD = {
    start: '/',

    tournaments: {
        participants: schedule => `/tournaments/${schedule?.id_tournament}/schedule/${schedule?.id}/participants`,
        participant: (scheduleItem) => `/tournaments/${scheduleItem?.id_tournament}/schedule/${scheduleItem?.id_tournament_schedule}/participant/${scheduleItem?.participant?.id}`,
    },

    

};
